// src/components/Groups/GoogleClassroomImportForGroups.tsx

import React, { useState } from 'react';
import { Box, Button, Typography, Alert } from '@mui/material';
import GoogleClassroomImport from '../Students/GoogleClassroomImport';

interface GoogleClassroomImportForGroupsProps {
  selectedGroupId: string;
  onImportSuccess: () => void;
}

const GoogleClassroomImportForGroups: React.FC<GoogleClassroomImportForGroupsProps> = ({
  selectedGroupId,
  onImportSuccess,
}) => {
  const [importCompleted, setImportCompleted] = useState(false);

  const handleImportComplete = () => {
    setImportCompleted(true);
    onImportSuccess();
  };

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Import students from Google Classroom. After import, you can assign them to this group 
        using the "Assign Existing" tab.
      </Typography>
      
      {importCompleted && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Students imported successfully! Switch to the "Assign Existing" tab to assign them to this group.
        </Alert>
      )}
      
      <GoogleClassroomImport />
    </Box>
  );
};

export default GoogleClassroomImportForGroups;
